import React from "react";
import { Tag } from "antd";
import moment from "moment";

const statusColors = {
  pending: "orange",
  approved: "green",
  rejected: "red"
};

export const columns = ({ onView, onEdit, onApprove, onReject }) => [
  {
    title: "School",
    key: "name",
    render: (_, record) => (
      <div>
        <div>{record.name}</div>
        <small>{record.primaryEmail}</small>
      </div>
    )
  },
  {
    title: "Location",
    key: "location",
    render: (_, record) => `${record.city}, ${record.country}`
  },
  {
    title: "Tier",
    dataIndex: "membershipTier",
    key: "membershipTier"
  },
  {
    title: "Staff",
    key: "staff",
    render: (_, record) => `${record.currentStaffCount || 0}/${record.staffLimit || 0}`
  },
  {
    title: "Status",
    key: "registrationStatus",
    render: (_, record) => (
      <Tag color={statusColors[record.registrationStatus] || "blue"}>
        {record.registrationStatus}
      </Tag>
    )
  },
  {
    title: "Expires",
    key: "expiryDate",
    render: (_, record) =>
      record.expiryDate ? moment(record.expiryDate).format("YYYY-MM-DD") : "N/A"
  },
  {
    title: "Active",
    key: "isActive",
    render: (_, record) => (
      <Tag color={record.isActive ? "green" : "red"}>
        {record.isActive ? "Yes" : "No"}
      </Tag>
    )
  },
  {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <div style={{ display: "flex", flexWrap: "wrap", margin: "-4px" }}>
        <div style={{ margin: "4px" }}>
          <a onClick={() => onView(record)}>View</a>
        </div>
        <div style={{ margin: "4px" }}>
          <a onClick={() => onEdit(record)}>Edit</a>
        </div>
        {record.registrationStatus === "pending" && (
          <>
            <div style={{ margin: "4px" }}>
              <a onClick={() => onApprove(record)}>Approve</a>
            </div>
            <div style={{ margin: "4px" }}>
              <a onClick={() => onReject(record)}>Reject</a>
            </div>
          </>
        )}
      </div>
    )
  }
];
